<template>
  <b-overlay
    :show="loading"
    rounded="sm"
    spinner-variant="success"
    spinner-type="grow"
  >
    <b-container fluid>
      <b-row class="mb-3">
        <b-col cols="12">
          <PageHeader
            :title="employeeData.birthName"
            :enable-back-link="true"
          />
        </b-col>
      </b-row>
      <b-row class="font-poppins">
        <b-col cols="12">
          <div>
            <ImageUploaderWage
                :api-call="apiCall"
                :is-employee-upload="isEmployeeUpload"
                :router-link="routerLink"
                :employee="employeeData"
                :doc-type="docType"
            />
          </div>
        </b-col>
      </b-row>
    </b-container>
  </b-overlay>
</template>

<script>
import PageHeader from "../../../components/PageHeader";
import Api from "api-client";
import { mapGetters } from "vuex";
import ImageUploaderWage from "@/components/wage/ImageUploaderWage.vue";

export default {
  name: "NewDocUploadForEmployee",
  components: {
    ImageUploaderWage,
    PageHeader,
  },
  data() {
    return {
      isTemporaryEmployee: false,
      docType: "fixEmployee",
      apiCall: {
        apiCallback: Api.uploadEmployeeDocs,
      },
      isEmployeeUpload: true,
      employeeData: {},
      loading: false,
    };
  },
  computed: {
    routerLink: function () {
      return "/app/employee/edit/" + this.$route.params.id;
    },
    ...mapGetters("app", ["getActiveCompany"]),
  },
  created() {
    let self = this;
    self.loading = true;
    Api.getEmployeeById(self.$route.params.id).then((resp) => {
      self.employeeData = resp.data;
      self.loading = false;
    });
    let params = {
      companyId: self.getActiveCompany.id,
      employeeId: +self.$route.params.id,
    };
    Api.isTemporaryEmployee(params)
      .then((resp) => {
        self.isTemporary = resp.data;
        self.docType = self.isTemporary ? "tempEmployee" : "fixEmployee";
      })
      .catch((error) => {
        console.error(error);
      });
  },
};
</script>

<style scoped></style>
